export const ALL_RESELLER = "ALL_RESELLER";
export const ALL_RESELLER_COUNT = "ALL_RESELLER_COUNT";
export const SEL_RESELLER = "SEL_RESELLER";

export const RESELLER_BUSINESS = "RESELLER_BUSINESS";
